const term = require('./term.json');
const identities = require('./identities');
const objectId = require('./object-id.json');
const feeConfiguration = require('./fee-configuration.json');
const employment = require('./employment.json');

/**
 * @readonly
 * @enum {string}
 */
const UnitEnum = {
  /** months */
  MONTHS: 'months',
  /** years */
  YEARS: 'years',
};

/**
 * @typedef {Object} ProductCategoryType
 * @readonly
 * @property {String} HOME_LOAN home-loan
 * @property {String} MOTOR_VEHICLE_LOAN motor-vehicle-loan
 * */

/**
 * @readonly
 * @enum {ProductCategoryType}
 */
const ProductCategoryType = {
  /** home-loan */
  HOME_LOAN: 'home-loan',
  /** motor-vehicle-loan */
  MOTOR_VEHICLE_LOAN: 'motor-vehicle-loan',
};

/**
 * @typedef {Object} ObjectId
 * @property {string} ObjectId - A 24 character long hexadecimal string. Must match pattern '^[a-f\\d]{24}$'.
 */

/**
 * @typedef {Object} Term
 * @property {UnitEnum} unit - The unit of term. Required.
 * @property {number} value - The value of Term. Required.
 */
/**
 * Common validation schemas
 * @module schemas/common
 * @property {IdentityDocument} identities - the common identities schema
 * @property {Term} term - the common term schema
 * @property {ObjectId} objectId - object id format
 * @property {Employment} employment - the common employment schema
 */
module.exports = {
  term,
  identities,
  objectId,
  feeConfiguration,
  employment,
};
